import { Flex, Text, type FlexProps, type SelectProps } from '@mantine/core';
import classes from './FormCompanyTypesSelect.module.scss';
import { CompanyTypesSelect } from '../CompanyTypesSelect';

interface FormCompanyTypesSelect extends SelectProps {
  title?: string;
  description?: string;
  containerProps?: FlexProps;
}

export const FormCompanyTypesSelect = ({
  title = 'Форма организации',
  description = 'Выберите организационно-правовую форму компании',
  containerProps,
  ...props
}: FormCompanyTypesSelect) => {
  return (
    <Flex gap='24' className={classes.formRow} {...containerProps}>
      <Flex direction='column' gap={6} className={classes.leftColumn}>
        <Text className={classes.title}>{title}</Text>
        <Text className={classes.description}>{description}</Text>
      </Flex>

      <CompanyTypesSelect
        {...props}
        className={classes.rightColumn}
        variant='filled'
      />
    </Flex>
  );
};
